import { useState } from "react";

export const useLoading = (loading = true) => {
  const [isLoading, setIsLoading] = useState(loading);

  return { isLoading, setIsLoading };
}